import React, { useContext, useState } from "react";
import { Button, App, Descriptions, Space, Typography, Popconfirm } from "antd";
import dayjs from 'dayjs'
import { jsPDF } from "jspdf";
import _ from "lodash";
import { Enum, API, ActionType, Font } from "../../resources/constants";
import language from "../../resources/languages/fa_IR";

// Interfaces
import { AxiosError, AxiosResponsePaginate } from "../../interfaces/axios"

// Contexts
import GlobalContext from '../../contexts/global';
import AxiosContext from "../../contexts/axios";

const currency = new Intl.NumberFormat()
const { Components: { Ticket }, Enum: EnumLanguage, Message: MessageLanguage } = language
const { SET_OPEN_DRAWER, SET_TRAVEL, SET_FILTER} = ActionType
const { TRAVEL_BOOKING_CANCEL, TRAVEL_TRAVEL_MY_PAGINATE } = API
const { Message, TravelType } = Enum
const { IRANSans, IRANSansFaNum } = Font

export default function Index() {

    const { travel, user, dispatch } = useContext(GlobalContext)
    const [loading, setLoading] = useState<boolean>(false)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    const getTravel = async () => {
        dispatch({ type: SET_FILTER , payload: { filter: {} }})
        await axios.post(TRAVEL_TRAVEL_MY_PAGINATE, {}, { params: { page: 1, limit: 1 }}).then((response: AxiosResponsePaginate) => {
            const { data, data: { docs } } = response
            const travel =  docs.length ? { ...docs[0], paginate: { ...data, docs: null } } : {}
            dispatch({ type: SET_TRAVEL , payload: { travel }})
        }).catch( (error: AxiosError) => {
            const { response: { data } } = error;
            dispatch({ type: SET_TRAVEL , payload: { travel: {} }})
            // @ts-ignore
            message.error(MessageLanguage[Message.ERROR_REQUEST]).then(response => response)
        })
    }

    if (travel && !_.isEmpty(travel)) {
        // @ts-ignore
        const { origin, originLocation, destination, destinationLocation, date, car, owner, bookings, number: code } = travel
        // @ts-ignore
        const { id, number, personCount, price, travelType } = bookings[0]
        // @ts-ignore
        const { firstName, lastName, mobile, nationalCode } = user;

        return (
            <Space direction={'vertical'} style={{ width: '100%' }} size={'large'}>
                <Descriptions bordered size={'small'}>
                    <Descriptions.Item key={'number'} span={24} label={`${Ticket.number}:`}>{number}</Descriptions.Item>
                    <Descriptions.Item key={'code'} span={24} label={`${Ticket.code}:`}>{code}</Descriptions.Item>
                    <Descriptions.Item key={'name'} span={24} label={`${Ticket.name}:`}>{firstName} {lastName}</Descriptions.Item>
                    <Descriptions.Item key={'nationalCode'} span={24} label={`${Ticket.nationalCode}:`}>{nationalCode}</Descriptions.Item>
                    <Descriptions.Item key={'mobile'} span={24} label={`${Ticket.mobile}:`}>0{mobile}</Descriptions.Item>
                    <Descriptions.Item key={'origin'} span={24} label={`${Ticket.origin}:`}>{origin.name}</Descriptions.Item>
                    <Descriptions.Item key={'destination'} span={24} label={`${Ticket.destination}:`}>{destination.name}</Descriptions.Item>
                    <Descriptions.Item key={'date'} span={24} label={`${Ticket.date}:`}>{dayjs(date).format('YYYY/MM/DD')}</Descriptions.Item>
                    <Descriptions.Item key={'time'} span={24} label={`${Ticket.time}:`}>{dayjs(date).format('HH:mm')}</Descriptions.Item>
                    {(travelType !== TravelType.Home) && <Descriptions.Item key={'address'} span={24} label={`${Ticket.address}:`}>{originLocation.address}</Descriptions.Item>}
                    <Descriptions.Item span={24} key={'travelType'} label={`${Ticket.travelType}:`}>{
                        // @ts-ignore
                        EnumLanguage.TravelType[travelType]
                    }</Descriptions.Item>
                    <Descriptions.Item span={24} key={'car'} label={`${Ticket.car}:`}>{car.name}</Descriptions.Item>
                    {(travelType === TravelType.Person) && <Descriptions.Item span={24} key={'seat'} label={`${Ticket.seat}:`}>{personCount}</Descriptions.Item>}
                    <Descriptions.Item span={24} key={'company'} label={`${Ticket.company}:`}>{owner.company}</Descriptions.Item>
                    <Descriptions.Item span={24} key={'tel'} label={`${Ticket.tel}:`}>{owner.tel}</Descriptions.Item>
                    <Descriptions.Item span={24} key={'price'} label={`${Ticket.price}:`} className={'booking-price'}>
                        <Typography.Text strong>{currency.format(price/10)}</Typography.Text>
                        <Typography.Text style={{marginRight: 5}}>{Ticket.toman}</Typography.Text>
                    </Descriptions.Item>
                </Descriptions>
                <Button block type="primary" onClick={() => {
                    const width = 80;
                    const height = 300;
                    const doc = new jsPDF("p", "mm", [width, height]);
                    doc.addFileToVFS("IRANSans.ttf", IRANSans);
                    doc.addFont("IRANSans.ttf", "IRANSans", "normal");
                    doc.addFileToVFS("IRANSansFaNum.ttf", IRANSansFaNum);
                    doc.addFont("IRANSansFaNum.ttf", "IRANSansFaNum", "normal");
                    doc.setLanguage("fa-IR");
                    const x = 40;
                    const x2 = 75;
                    const x3 = 5;
                    const x4 = 15;
                    const w = 70;
                    const w2 = 50;
                    const h2 = 54;
                    let y = 3;

                    doc.addImage(require('../../resources/media/logo-resize/safar30.png'), x4, y, w2, h2);
                    y = y + 55;

                    doc.setFont("IRANSansFaNum");
                    doc.setFontSize(9);

                    const body = (title: string, value: string, show: boolean, split: boolean) => {
                        if (show) {
                            doc.setTextColor("white");
                            y = y + 7;
                            doc.rect(x3, y - 4.5, w, 6, "F");
                            // @ts-ignore
                            doc.text(':' + title, x, y - 0.5, null, null, 'center');
                            y = y + 2;
                            doc.line(5, y, x2, y);
                            doc.setTextColor("black");
                            split && doc.setLineHeightFactor(1.7);
                            y = y + 5;
                            // @ts-ignore
                            doc.text(split ? doc.splitTextToSize(value, width) : value, x, y, null, null, 'center');
                        }
                    }

                    for (const { title, value, show, split} of [
                        {
                            title: Ticket.number,
                            value: number.toString(),
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.code,
                            value: code.toString(),
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.name,
                            value: `${firstName} ${lastName}`,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.nationalCode,
                            value: nationalCode.toString(),
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.mobile,
                            value: `0${mobile}`,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.origin,
                            value: origin.name,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.destination,
                            value: destination.name,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.date,
                            value: dayjs(date).format('YYYY/MM/DD'),
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.time,
                            value: dayjs(date).format('HH:mm'),
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.travelType,
                            // @ts-ignore
                            value: EnumLanguage.TravelType[travelType],
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.car,
                            value: car.name,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.seat,
                            value: personCount && personCount.toString(),
                            show: travelType === TravelType.Person,
                            split: false,
                        },
                        {
                            title: Ticket.company,
                            value: owner.company,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.tel,
                            value: owner.tel,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.price,
                            value: `${currency.format(price/10)} ${Ticket.toman}`,
                            show: true,
                            split: false,
                        },
                        {
                            title: Ticket.address,
                            value: originLocation.address,
                            show: travelType !== TravelType.Home,
                            split: true,
                        },
                    ])
                        body(title, value, show, split);

                    // doc.autoPrint();
                    // doc.output("datauristring");
                    // doc.output("dataurlnewwindow");
                    doc.save(`${number}.pdf`);
                }}>{Ticket.download}</Button>
                <Popconfirm
                    title={Ticket.cancel}
                    description={Ticket.cancelConfirm}
                    okText={Ticket.cancelYes}
                    cancelText={Ticket.cancelNo}
                    onConfirm={() => {
                        setLoading(true)
                        axios.get(TRAVEL_BOOKING_CANCEL + id).then(async (response: {}) => {
                            await getTravel()
                            dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: false }})
                            setLoading(false)
                            message.success(MessageLanguage[Message.TICKET_CANCEL]).then(response => response)
                        }).catch( (error: AxiosError) => {
                            const { response: { data } } = error;
                            setLoading(false)
                            // @ts-ignore
                            message.error(MessageLanguage[data.message]).then(response => response)
                        })
                    }}
                >
                    <Button loading={loading} block danger type="primary">{Ticket.cancel}</Button>
                </Popconfirm>
            </Space>
        )
    } else return <></>
}
